export const weatherTypeOptionsData = [
    {
        content: "Actuelle",
        value: "current",
    },
    {
        content: "Journalière",
        value: "daily",
    },
    {
        content: "Toutes les 3H",
        value: "hourly",
    },
];
export const weatherUnitOptionsData = [
    {
        content: "°C",
        value: "celcius",
    },
    {
        content: "°F",
        value: "fahrenheit",
    },
];
export const weatherThemeOptionsData = [
    {
        content: "Défaut",
        value: "default",
    },
    {
        content: "Personnalisé",
        value: "custom",
    },
];
export const weatherBackgroundColorTypeOptionsData = [
    {
        content: "Couleur simple",
        value: "color",
    },
    {
        content: "Dégradé",
        value: "gradient",
    },
];
